module.exports = __webpack_public_path__ + "img/08.8bc98cda.png";